import React, { useState } from 'react';
import { Report, Document, IbmWatsonDiscovery } from '@carbon/icons-react';
import { Stack, DatePicker, DatePickerInput, Select, SelectItem, Button, FileUploader, InlineNotification } from '@carbon/react';
import Card from '../../../components/Layouts/Card';
import Typography from '../../../components/Basics/Typography';
import { Tabs, TabList, Tab, TabPanels, TabPanel, Modal } from "@carbon/react";
import { DataTable as DataTableIcon } from "@carbon/icons-react";
import InformationContainer from '../../../components/Basics/Information.container';
import { CardComponent, CardRow } from '../../../components/Layouts/Card.styles';
import { Iframe } from '../../../components/Basics/Iframe.styles';
import { InputWrapper } from '../../../containers/Notifications/Notifications.styles';
import ExpansionTable from '../../../components/Basics/ExpansionTable.container';
import EditModal from '../../../components/Basics/EditModal.container';
import { Separator } from '../../Dashboard/Dashboard.styles';
import SearchTable from '../../../components/Basics/SearchTable.container';
import SelectableTable from '../../../components/Basics/SelectTable.container';

/**
 * The Map's Page.
 */
const ReportContainer = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedReport, setSelectedReport] = useState(null);
    const [fileUploaded, setFileUploaded] = useState(null);
    const [isModalOpen_3, setIsModalOpen_3] = useState(false);

    const openModal = (row) => {
        setSelectedReport(row);
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
        setSelectedReport(null);
    };

    const today = new Date();
    const yesterday = new Date(today);
    yesterday.setDate(today.getDate());

    const [isModalOpen_2, setIsModalOpen_2] = useState(false);

    const openModal_2 = () => setIsModalOpen_2(true);
    const closeModal_2 = () => setIsModalOpen_2(false);

    const rows = [
        { id: '1', conductor:'id_conductor', servicio:'A123', ot:'10', name: 'VC-71', rule: 'miércoles, 26 de junio de 2024', status: 'KCL' },
        { id: '2', conductor:'id_conductor', servicio:'A123', ot:'10', name: 'VC-72', rule: 'miércoles, 26 de junio de 2024', status: 'KCL' },
        { id: '3', conductor:'id_conductor', servicio:'A123', ot:'10', name: 'VC-73', rule: 'miércoles, 26 de junio de 2024', status: 'KCL' },
        { id: '4', conductor:'id_conductor', servicio:'A123', ot:'10', name: 'VC-74', rule: 'miércoles, 26 de junio de 2024', status: 'KCL' },
        { id: '5', conductor:'id_conductor', servicio:'A123', ot:'10', name: 'VC-75', rule: 'miércoles, 26 de junio de 2024', status: 'KCL' },
        { id: '6', conductor:'id_conductor', servicio:'A123', ot:'10', name: 'VC-76', rule: 'miércoles, 26 de junio de 2024', status: 'KCL' },
        { id: '7', conductor:'id_conductor', servicio:'A123', ot:'10', name: 'VC-77', rule: 'miércoles, 26 de junio de 2024', status: 'KCL' }
    ];

    const headers = [
        { key: 'conductor', header: 'Conductor' },
        { key: 'servicio', header: 'Servicio (Código)' },
        { key: 'ot', header: 'Ordenes de trabajo' },
        { key: 'name', header: 'Equipo asignado' },
        { key: 'rule', header: 'Fecha del reporte' }
    ];

    const rows_2 = [
        {
            id: 'g',
            ot: '324273',
            equipo: 'Equipo 1',
            tipo: 'Lavado',
            servicio: 'Aljibes',
            ubicacion: 'Mina Norte',
            conductor: 'Juanito Perez',
            estado: 'completas',
            horo_inicio: '08:00',
            horo_termino: '14:00',
            vol_inicial: '12',
            vol_final: '5',
            flu_inicial: '12',
            flu_final: '5',
        },
        {
            id: 'h',
            ot: '324274',
            equipo: 'Equipo 2',
            tipo: 'Lavado',
            servicio: 'Aljibes',
            ubicacion: 'Mina Norte',
            conductor: 'Juanito Perez',
            estado: 'completas',
            horo_inicio: '08:00',
            horo_termino: '14:00',
            vol_inicial: '12',
            vol_final: '5',
            flu_inicial: '12',
            flu_final: '5',
        },
        {
            id: 'i',
            ot: '324275',
            equipo: 'Equipo 3',
            tipo: 'Lavado',
            servicio: 'Aljibes',
            ubicacion: 'Mina Norte',
            conductor: 'Juanito Perez',
            estado: 'completas',
            horo_inicio: '08:00',
            horo_termino: '14:00',
            vol_inicial: '12',
            vol_final: '5',
            flu_inicial: '12',
            flu_final: '5',
        },
        {
            id: 'j',
            ot: '324276',
            equipo: 'Equipo 4',
            tipo: 'Lavado',
            servicio: 'Aljibes',
            ubicacion: 'Mina Norte',
            conductor: 'Juanito Perez',
            estado: 'completas',
            horo_inicio: '08:00',
            horo_termino: '14:00',
            vol_inicial: '12',
            vol_final: '5',
            flu_inicial: '12',
            flu_final: '5',
        },
        {
            id: 'k',
            ot: '324277',
            equipo: 'Equipo 5',
            tipo: 'Lavado',
            servicio: 'Aljibes',
            ubicacion: 'Mina Norte',
            conductor: 'Juanito Perez',
            estado: 'completas',
            horo_inicio: '08:00',
            horo_termino: '14:00',
            vol_inicial: '12',
            vol_final: '5',
            flu_inicial: '12',
            flu_final: '5',
        },
        {
            id: 'l',
            ot: '324278',
            equipo: 'Equipo 6',
            tipo: 'Lavado',
            servicio: 'Aljibes',
            ubicacion: 'Mina Norte',
            conductor: 'Juanito Perez',
            estado: 'completas',
            horo_inicio: '08:00',
            horo_termino: '14:00',
            vol_inicial: '12',
            vol_final: '5',
            flu_inicial: '12',
            flu_final: '5',
        },
    ];

    const headers_2 = [
        { key: 'ot', header: 'ID' },
        { key: 'equipo', header: 'Equipo' },
        { key: 'tipo', header: 'Tipo de OT' },
        { key: 'servicio', header: 'Servicio' },
        { key: 'ubicacion', header: 'Ubicación' },
        { key: 'conductor', header: 'Conductor Responsable' },
        { key: 'estado', header: 'Estado de la OT' },
        { key: 'horo_inicio', header: 'Horómetro Inicial' },
        { key: 'horo_termino', header: 'Horómetro Final' },
        { key: 'vol_inicial', header: 'Vol Inicial' },
        { key: 'vol_final', header: 'Vol Final' },
        { key: 'flu_inicial', header: 'Flujo Inicial' },
        { key: 'flu_final', header: 'Flujo Final' }
    ];

    const rows_3 = [
        { id: '8', conductor:'id_conductor', servicio:'A123', ot:'10', name: 'VC-71', rule: 'miércoles, 26 de junio de 2024', status: 'KCL' },
        { id: '9', conductor:'id_conductor', servicio:'A123', ot:'10', name: 'VC-72', rule: 'miércoles, 26 de junio de 2024', status: 'KCL' },
        { id: '10', conductor:'id_conductor', servicio:'A123', ot:'10', name: 'VC-73', rule: 'miércoles, 26 de junio de 2024', status: 'KCL' },
        { id: '11', conductor:'id_conductor', servicio:'A123', ot:'10', name: 'VC-74', rule: 'miércoles, 26 de junio de 2024', status: 'KCL' },
        { id: '12', conductor:'id_conductor', servicio:'A123', ot:'10', name: 'VC-75', rule: 'miércoles, 26 de junio de 2024', status: 'KCL' },
        { id: '13', conductor:'id_conductor', servicio:'A123', ot:'10', name: 'VC-76', rule: 'miércoles, 26 de junio de 2024', status: 'KCL' },
        { id: '14', conductor:'id_conductor', servicio:'A123', ot:'10', name: 'VC-77', rule: 'miércoles, 26 de junio de 2024', status: 'KCL' }
    ];

    const headers_3 = [
        { key: 'conductor', header: 'Conductor' },
        { key: 'servicio', header: 'Servicio (Código)' },
        { key: 'ot', header: 'Ordenes de trabajo' },
        { key: 'name', header: 'Equipo asignado' },
        { key: 'rule', header: 'Fecha del reporte' }
    ];

    return (
            <Tabs>
                <TabList activation="manual" aria-label="List of tabs">
                    <Tab>Reportes de hoy</Tab>
                    <Tab>Reportes anteriores</Tab>
                </TabList>
                <TabPanels>
                    <TabPanel style={{ width: '100%' }}>
                        <Stack gap={3}>
                            <Card $justifyContent='flex-start' background="transparent" flexDirection="column" alignItems='flex-start'>
                                <p style={{ color: '#8D8D8D' }}>Herramientas asociadas al módulo</p>
                                <Separator />
                                <Stack orientation="horizontal">
                                    <Button
                                        renderIcon={Document}
                                        kind="secondary"
                                        size="sm"
                                        style={{ backgroundColor: '#6C757D', color: '#FFF', width: 'fit-content', whiteSpace: 'nowrap' }}
                                        onClick={openModal_2}
                                    >
                                        Buscar y Asociar Reportes al Turno
                                    </Button>
                                    <Button
                                        renderIcon={Document}
                                        kind="secondary"
                                        size="sm"
                                        style={{ backgroundColor: '#6C757D', color: '#FFF', width: 'fit-content', whiteSpace: 'nowrap' }}
                                        onClick={() => setIsModalOpen_3(true)}
                                    >
                                        Crear reportes de forma manual
                                    </Button>
                                </Stack>
                            </Card>
                            <Card $justifyContent='flex-start' background="transparent" flexDirection="column" alignItems='flex-start'>
                                <SearchTable rows={rows} headers={headers} title='Reportes cargados'/>
                            </Card>
                        </Stack>
                        <Modal
                            open={isModalOpen_2}
                            modalHeading="Buscar y Asociar Reportes al Turno"
                            primaryButtonText="Cargar reportes"
                            secondaryButtonText="Cancelar"
                            onRequestClose={closeModal_2}
                            onRequestSubmit={() => alert('Reportes cargados')}
                            size="lg"
                        >
                            <p>Utiliza el botón de búsqueda para encontrar reportes que aún no están asociados a este turno. Una vez encontrados, selecciona los reportes que deseas cargar.</p>
                            <Button size='md' kind="primary" renderIcon={IbmWatsonDiscovery}>
                                Buscar datos
                            </Button>
                            <SelectableTable rows={rows} headers={headers} />
                        </Modal>
                        <Modal
                            open={isModalOpen_3}
                            modalHeading="Cargar reportes de forma manual"
                            primaryButtonText="Cargar OTs"
                            secondaryButtonText="Cancelar"
                            primaryButtonDisabled={!fileUploaded}
                            onRequestClose={() => setIsModalOpen_3(false)}
                            onRequestSubmit={() => {
                                setIsModalOpen_3(false);
                                alert("Carga iniciada");
                            }}
                        >
                            <Stack gap={5}>
                                <p>Por favor seleccione los reportes que desea cargar a la plataforma.</p>
                                <p>Cargar reportes</p>
                            </Stack>
                            <p style={{ color: '#8D8D8D'}}>Este formulario solo es capaz de leer reportes con las siguientes columnas:</p>
                            <p style={{ color: '#8D8D8D'}}>ID</p>
                            <p style={{ color: '#8D8D8D'}}>Equipo</p>
                            <p style={{ color: '#8D8D8D'}}>Tipo de OT</p>
                            <p style={{ color: '#8D8D8D'}}>Servicio</p>
                            <p style={{ color: '#8D8D8D'}}>Ubicación</p>
                            <p style={{ color: '#8D8D8D'}}>Conductor Responsable</p>
                            <p style={{ color: '#8D8D8D'}}>Estado de la OT</p>
                            <p style={{ color: '#8D8D8D'}}>Horómetro Inicial</p>
                            <p style={{ color: '#8D8D8D'}}>Horómetro Final</p>
                            <p style={{ color: '#8D8D8D'}}>Vol Inicial</p>
                            <p style={{ color: '#8D8D8D'}}>Vol Final</p>
                            <p style={{ color: '#8D8D8D'}}>Flujo Inicial</p>
                            <p style={{ color: '#8D8D8D'}}>Flujo Final</p>
            
                            <FileUploader
                                labelDescription=""
                                buttonLabel="Seleccionar archivo"
                                filenameStatus="edit"
                                accept={[".csv", ".xlsx"]}
                                iconDescription="Borrar archivo"
                                onChange={(event) => setFileUploaded(event.target.files[0])}
                            />
            
                            {fileUploaded && (
                                <InlineNotification
                                    kind="info"
                                    iconDescription="Información"
                                    title="Revise los campos del documento antes de confirmar el formulario."
                                    style={{ backgroundColor: 'transparent' }}
                                    lowContrast
                                />
                            )}
                        </Modal>
                    </TabPanel>
                    <TabPanel style={{ width: '100%' }}>
                        <Stack gap={3}>
                            <CardComponent width="100%">
                                <Card $justifyContent='flex-start' background="transparent" flexDirection="column" alignItems='flex-start'>
                                    <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
                                        <DatePicker datePickerType="single" maxDate={yesterday.toISOString()} dateFormat='d-m-Y'>
                                            <DatePickerInput placeholder="dd/mm/yyyy" labelText="Fecha de los reportes" id="daily-datepicker" size="md" />
                                        </DatePicker>
                                        <p style={{ color: '#8D8D8D', fontSize: '0.8rem' }}>Seleccione una fecha diferente a la de hoy</p>
                                    </div>
                                </Card>
                                <Card $justifyContent='flex-start' background="transparent" flexDirection="column" alignItems='flex-start'>
                                    <SearchTable rows={rows_3} headers={headers_3} onActionClick={openModal} actionButtonText='Ver OTs del reporte' title='Reportes cargados'/>
                                </Card>
                            </CardComponent>
                        </Stack>
                        <Modal
                            open={isModalOpen}
                            modalHeading={`Reportes anteriores`}
                            primaryButtonText="Cerrar"
                            onRequestClose={closeModal}
                            onRequestSubmit={closeModal}
                            size="lg"
                        >
                            <p>{selectedReport?.cells.find(cell => cell.info.header === 'rule')?.value}</p>
                            <p>{selectedReport?.cells.find(cell => cell.info.header === 'conductor')?.value}</p>
                            <p>{selectedReport?.cells.find(cell => cell.info.header === 'name')?.value}</p>
                            <SearchTable rows={rows_2} headers={headers_2} title="Órdenes de Trabajo" />
                        </Modal>
                    </TabPanel>
                </TabPanels>
            </Tabs>
    );
};

export default ReportContainer;
